import { encodeGetParams, getHeaders } from '../common/util';
import { POST } from '../common/consts';
import { API_URL } from '../circulusConfig';

const signinAPI = async (userId, password) => {
  const res = await fetch(
    `${API_URL}user/signin`,
    getHeaders(POST, { userId, password }),
  );
  return res.ok ? res.json() : Promise.reject(res);
};

const signupAPI = async (body) => {
  const res = await fetch(`${API_URL}user/signup`, getHeaders(POST, body));
  return res.ok ? res.json() : Promise.reject(res);
};

const checkuserIdAPI = async (userId) => {
  const res = await fetch(`${API_URL}user/checkid/${userId}`);
  return res.ok ? res.json() : Promise.reject(res);
};

const checkInfoAPI = async ({ type, value }) => {
  const res = await fetch(`${API_URL}user/checkInfo/${type}/${value}`);
  return res.ok ? res.json() : Promise.reject(res);
};

const checkEmailAuthAPI = async (userPId) => {
  const res = await fetch(`${API_URL}user/checkauth/${userPId}`);
  return res.ok ? res.json() : Promise.reject(res);
};

const sendVerificationAPI = async ({ email, tel, type, userId, userOId }) => {
  const res = await fetch(
    `${API_URL}user/sendVerification?${encodeGetParams({
      email,
      tel,
      type,
      userId,
      userOId,
    })}`,
  );
  return res.ok ? res.json() : Promise.reject(res);
};

// 인증 메일 확인 시 검증
const confirmCertCodeAPI = async ({ code, type, userOId }) => {
  const res = await fetch(
    `${API_URL}user/verify/${type}/${code}?${encodeGetParams({
      userOId,
    })}`,
  );
  return res.ok ? res.json() : Promise.reject(res);
};

const imageUploadAPI = async (formData) => {
  const res = await fetch(`${API_URL}image/upload`, {
    method: 'POST',
    headers: {
      'multipart/form-data': formData,
    },
  });
  return res.ok ? res.json() : Promise.reject(res);
};

const userVerifyAPI = async (token) => {
  const res = await fetch(`${API_URL}user/verify/check`, {
    method: 'GET',
    headers: {
      'x-access-token': token,
    },
  });
  return res.ok ? res.json() : Promise.reject(res);
};

const signoutAPI = async (data) => {
  const res = await fetch(`${API_URL}user/signout`, getHeaders(POST, data));
  const result = res.json();
  return result;
};

const verifyingEmailAPI = async ({ type, serial }) => {
  const res = await fetch(`${API_URL}user/verification/${type}/${serial}`);
  const result = res.json();
  return result;
};

export {
  signinAPI,
  signupAPI,
  checkuserIdAPI,
  checkInfoAPI,
  checkEmailAuthAPI,
  sendVerificationAPI,
  imageUploadAPI,
  userVerifyAPI,
  signoutAPI,
  verifyingEmailAPI,
  confirmCertCodeAPI,
};
